import type { HostToIframeEvent } from './events'

export class MessageQueue {
  private items: HostToIframeEvent[] = []

  enqueue(message: HostToIframeEvent) {
    this.items.push(message)
  }

  clear() {
    this.items = []
  }

  flush(send: (message: HostToIframeEvent) => void) {
    while (this.items.length > 0) {
      const next = this.items.shift()
      if (next) send(next)
    }
  }
}